<template>
  <div>
      <h3>Email verified,Thank you. Redirecting to the login page now.....</h3>
  </div>
</template>

<script>
import router from "../router"
export default {
    mounted() {
        setTimeout(()=>{
            router.push('/login')
        },
        2000)
    }
}
</script>

<style>

</style>
